import {checkNull} from '@/helpers'

export default {
    name: 'user-home',
    data() {
        return {
            default_avatar_male: `${window.APP_CONFIG.CDN_URL}/images/male.png`,
            default_avatar_female: `${window.APP_CONFIG.CDN_URL}/images/female.png`,
            cdn_url: window.APP_CONFIG.CDN_URL,
            toast_config: {
                horizontalPosition: 'center',
                verticalPosition: 'top',
                mode: 'override',
                message: 'Testing'
            },
            sub_nav: [
                { name: 'EDIT MY PROFILE', route: 'user-profile', icon_class: 'icon icon-profile' },
                { name: 'CONFIGURATION', route: 'user-settings', icon_class: 'icon icon-gear' },
                { name: 'ONLINE SUPPORT', route: 'contact', icon_class: 'icon icon-support' },
                { name: 'Log out', icon_class: 'icon icon-logout', action_name: 'logout', action_second_parent: true }
            ],
            fake_home: false,
            mobile_title: '',
            success_payment: false,
            recent_activity: [],
            loaded: false,
        }
    },
    computed: {
        webcam_url() {
            return this.$store.getters['pub/webcamUrl'];
        },
        avatarImage() {
            let p_id = this.$store.getters['auth/profile']['profile_image_id']
            if( checkNull( p_id ) ) return this.$store.getters['auth/profile']['profile_image']

            let b_gender = this.$store.getters['auth/profile']['sex']
            return checkNull(b_gender) ? (b_gender == 'male' ? this.default_avatar_male : this.default_avatar_female) : this.default_avatar_male
        },
        showDesktop() {
            return this.$root.$children[0].width > 1199
        },
        profile() {
            return this.$store.getters['auth/profile']
        },
        credits() {
            return this.$store.getters['auth/credits']
        },
        unreadMessages() {
            let i = this.$store.getters['auth/profile']['welcome_message'] == 1 ? 1 : 0
            let n = parseInt(this.$store.getters['auth/unreadNotifications'])
            return parseInt(this.$store.getters['auth/unreadMessages']) + i + n
        },
        subscriptionType() {
            return this.$store.getters['auth/subscriptionType']
        },
        isPremium() {
            return this.$store.getters['auth/premium']
        },
        subscriptionAllowed() {
            return this.$store.getters['auth/subscriptionAllowed']
        },
        isAuthenticated() {
            return this.$store.getters['auth/isAuthenticated']
        },
        topProfiles() {
            return this.$store.getters['profile/topProfiles']
        },
        newProfiles() {
            return this.$store.getters['profile/newProfiles']
        },
        recentActivity() {
            return this.$store.getters['profile/recentActivity']
        },
        gender() {
            return this.$store.getters['auth/profile']['sex']
        },
    },
    methods: {
        toggleFavorite(info) {
            if(!info.is_favorite) {
                this.addFavorite(info)
            } else {
                this.removeFavorite(info)
            }
        },
        addFavorite(info) {
            this.$store.dispatch('profile/addFavorite', { nick_name: info.nick_name })
                .then(res => {
                    info.is_favorite = true
                    this.$toast(this.$t('Favorite added successfully'), this.test_config)
                })
        },
        removeFavorite(info) {
            this.$store.dispatch('profile/removeFavorite', { nick_name: info.nick_name })
                .then(res => {
                    info.is_favorite = false
                    this.$toast(this.$t('Favorite deleted successfully'), this.toast_config)
                })
        },
        handleMessage(val) {
            this.$parent.changeModalContent({
                name: 'message-pop-up',
                hasCloseButton: true,
                alignCenter: false,
                canCloseBackDrop: true,
                layoutType: "small",
                props: val
            })
            this.$parent.$emit('open-modal')
        },
        logout() {
            this.$store.dispatch('auth/logout')
                .then(res => {
                    this.$router.push({ name: 'logged-out', params: { status: 'success', fromRemoveAuth: true } })
                }, res =>{
                    this.$router.push({ name: 'logged-out', params: { status: 'success', fromRemoveAuth: true } })
                })
        },
        handleClick() {
            if(!this.stats_loading && this.isAuthenticated) {
                this.stats_loading = true
                this.$store.dispatch('auth/getUser', {
                    success_cb: (res) => {
                        this.disableStatLoading()
                    },
                    error_cb: () => {
                        this.disableStatLoading()
                    }
                })
            }
        },
        disableStatLoading() {
            setTimeout(() => {
                this.stats_loading = false
            }, 5000)
        }
    },
    created() {
        window.addEventListener("click", this.handleClick)
    },
    beforeDestroy() {
        window.removeEventListener("click", this.handleClick)
    },
    mounted(){
        if(!this.isAuthenticated) {
            let is_from_api = checkNull(this.$route.query['from_api']) && checkNull(this.$route.query['id'])
            let is_from_smartlink = checkNull(this.$route.query['from_smartlink'])
            let query = is_from_api ? this.$route.query : {...this.$store.getters['cookies/getORegister'], ...this.$route.query}
            if(is_from_api || is_from_smartlink || checkNull(query['verify_only'])  ) {
                this.$store.dispatch('cookies/setORegister', null)
            }
            let trial_ended = this.$route.params['trial_ended'] ?? false
            if (trial_ended) {
                query = {...query, ...this.$route.params}
            }
            if(checkNull(query['sex_seeking']) && checkNull(query['province_id']) || checkNull(query['key']) ||
                (checkNull(query['error']) && query['error'] == 'no_account') || is_from_api || is_from_smartlink ||
                trial_ended || checkNull(query['verify_only']) ) {
                this.fake_home = true
                this.mobile_title = 'Register'
                this.$parent.changeModalContent({
                    name: 'register-follow-up-pop-up',
                    hasCloseButton: false,
                    alignCenter: true,
                    canCloseBackDrop: false,
                    extraClasses: "mobile-dark centered",
                    mobileBreakpoint: 1199,
                    props : {
                        sex_seeking: query['sex_seeking'],
                        province_id: query['province_id'],
                        country_id: checkNull(query['country_id']) ? query['country_id'] : '',
                        s_email: query['email'],
                        s_nick_name: query['nick_name'],
                        s_age: query['age'],
                        from_api: query['from_api'],
                        verify_only: is_from_smartlink || query['verify_only'],
                        trial_ended: trial_ended,
                        provider: query['provider'],
                        provider_id: query['provider_id'],
                        token: query['key'],
                        onboard: query['onboard'],
                        error_gmail_last_step: (checkNull(query['error']) && query['error'] == 'no_account'),
                        user_id: query['id'],
                        s_token_resend: query['token_resend'],
                        from_smartlink: is_from_smartlink
                    }
                })
                this.$parent.$emit('open-modal')
            } else {
                this.$router.push({ name: 'home' })
            }
        }

        if(this.$route.params.message)
            this.handleMessage(this.$route.params.message)

        const o_query = this.$route.query
        if(checkNull(o_query.status) && o_query.status == 'success') {
            if (checkNull(o_query.mtid)) {
                // paysafecard mtid
                this.$store.dispatch('payment/checkPayment', o_query.mtid).then(response => {
                    if (response?.data?.response?.toLowerCase() === 'success') {
                        this.success_payment = true
                    } else {
                        this.$router.push({
                            name: 'user-credits',
                            params: {error_message: this.$t('Something went wrong, please try again in 10 minutes')}
                        })
                    }
                })
            } else {
                this.success_payment = true
            }
        }

        if (['pending'].includes(o_query.status)) {
            this.$router.push({ name: 'user-home' })
        } else if(['canceled', 'failed', 'failure'].includes(o_query.status)) {
            let params = {};
            if(checkNull(o_query.error_msg)) {
                params['error_message'] = o_query.error_msg
            } else if(checkNull(o_query.mtid) || checkNull(o_query.transaction) || checkNull(o_query.PaymentRequestId)) {
                params['error_message'] = this.$t('Your payment has been cancelled')
            }
            const s_route = checkNull(o_query.redirect_to) && ['credits', 'premium'].includes(o_query.redirect_to) ? `user-${o_query.redirect_to}` : 'user-credits'
            this.$router.push({ name: s_route, params })
        }

        let prevRoute = this.$store.getters['pub/routePrev'];
        if (this.isAuthenticated && prevRoute && prevRoute.path !== this.$route.path) {
            this.$store.dispatch('profile/getDashboard', {updates: true});
        }

        this.recent_activity = this.recentActivity
        this.loaded = true
    },
    watch: {
        webcam_url: {
            handler(v) {
                const index = this.sub_nav.findIndex(e => e.name === "Cams");
                if(v) {
                    if (index === -1) {
                        this.sub_nav.push({ name: 'Cams', icon_class: 'icon icon-cam', action_name: 'redirectWebCamUrl', href: '/cams' })
                    }
                } else if(index !== -1) {
                    this.$delete(this.sub_nav, index);
                }
            },
            immediate: true
        },
        recentActivity(to, from) {
            this.recent_activity = to
        }
    }
}
